module.exports = __webpack_public_path__ + "assets/knockoutjs.f44e1692.svg";